import pages from './pages';
import urls from './utils/urls';

const routes = [

  /*
   * LANDING
   */
  {
    path: '/',
    Component: pages.landing.Brand,
  },
  {
    path: '/creators',
    Component: pages.landing.Creator,
  },
  {
    path: '/tiktok-landing',
    Component: pages.landing.TikTokLanding,
  },
  {
    path: '/:locale/tiktok-landing',
    Component: pages.landing.TikTokLanding,
  },

  /*
   * WIZARD
   */
  {
    path: '/wizard/email',
    Component: pages.wizard._01_Email,
  },
  {
    path: '/wizard/phone',
    Component: pages.wizard._02_Phone,
  },
  {
    path: '/wizard/profile',
    Component: pages.wizard._03_Profile,
  },
  {
    path: '/wizard/socials',
    Component: pages.wizard._04_Socials,
  },

  /*
   * CONTENTFUL
   */
  {
    path: '/blog',
    Component: () => (
      <pages.contentful.EntryList
        title='Blog'
        query={{
          content_type: 'pageBlogPost',
          order: '-fields.publishedDate',
        }}
        image={{
          field: 'featuredImage',
          mode: 'cover',
        }}
        link={(item) => `/blog/${item.fields.slug}`}
      />
    ),
  },
  {
    path: '/blog/:slug',
    Component: () => (
      <pages.contentful.EntryDetail
        query={{
          content_type: 'pageBlogPost',
        }}
      />
    ),
  },
  {
    path: '/case-studies',
    Component: () => (
      <pages.contentful.EntryList
        title='Case Studies'
        query={{
          content_type: 'caseStudy',
          order: '-fields.publishedDate',
        }}
        image={{
          field: 'brandLogo',
          mode: 'contain',
        }}
        link={(item) => `/case-studies/${item.fields.slug}`}
      />
    ),
  },
  {
    path: '/case-studies/:slug',
    Component: () => (
      <pages.contentful.EntryDetail
        query={{
          content_type: 'caseStudy',
        }}
      />
    ),
  },

  /*
   * CUSTOM
   */
  {
    path: '/blog/review-analysis-by-harnessing-chatgpt-prompts',
    Component: pages.custom.ChatGPT,
  },
  {
    path: '/blog/insights-on-social-media-trends-and-tiktok-ban',
    Component: pages.custom.Survey,
  },

  /*
   * LEGAL
   */
  {
    path: '/terms-and-conditions',
    Component: pages.legal.Terms,
  },
  {
    path: '/cookie-policy',
    Component: pages.legal.Cookies,
  },
  {
    path: '/privacy-policy',
    Component: pages.legal.Privacy,
  },
  {
    path: '/campaign-terms-conditions',
    Component: pages.legal.Campaign,
  },

  /*
   * USER -> PROFILE
   */
  {
    path: '/profile',
    Component: pages.user.profile.Home,
  },
  {
    path: '/edit-profile',
    Component: pages.user.profile.sections.Edit,
  },
  {
    path: '/change-picture',
    Component: pages.user.profile.sections.Media,
  },
  {
    path: '/change-address',
    Component: pages.user.profile.sections.Address,
  },
  {
    path: '/change-password',
    Component: pages.user.profile.sections.Password,
  },
  {
    path: '/privacy-settings',
    Component: pages.user.profile.sections.Privacy,
  },
  {
    path: '/email-settings',
    Component: pages.user.profile.sections.Email,
  },
  {
    path: '/social-networks',
    Component: pages.user.profile.sections.Socials,
  },

  /*
   * USER -> CAMPAIGNS
   */
  {
    path: '/campaigns',
    Component: pages.user.campaigns.Home,
  },
  {
    path: '/c',
    Component: () => <urls.Alias target='/campaigns' />,
  },

  /*
   * USER -> TAKES
   */
  {
    path: '/takes',
    Component: pages.user.products.ProductTinder,
  },
];

export default routes;